// extracted by mini-css-extract-plugin
export default {"page":"NotFoundPage_page__Yeawi","container":"NotFoundPage_container__XkGLH","video":"NotFoundPage_video__OgyVi"};